import { TradeName } from '../types/companyValues'

export const getPrimaryTradeName = (tradeNames: TradeName[] | undefined): TradeName | undefined =>
  tradeNames?.find((tradeName) => tradeName?.default) ?? tradeNames?.[0]
